// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index__14exrNpw{z-index:1000}.index_border__14exrNpw{border:1px solid #ccc}", ""]);
// Exports
exports.locals = {
	"root": "index__14exrNpw",
	"border": "index_border__14exrNpw"
};
module.exports = exports;
